export default __webpack_public_path__ + "media/images/dashboard/settings-0a8d4cf349245c3aca3aac4518c19367.svg";